import React from "react";

function Banner(props) {
  const {
    restaurantName,
    applicationType,
  } = props;

  return (
    <div className="ls-banner">
      {applicationType && applicationType === "MENU_TEST" && (
        <>
            <div className="restaurant-name">{restaurantName}</div>
        </>
      )}
    </div>
  );
}

export default Banner;
